/**
 * «Вопросы клиентов» (client-questions; ТЗ п.9.7, В29): вопросы, которые видны вошедшему, —
 * администратору и руководителю все, сотруднику — его клиентов (менеджер клиента, сопровождение) и
 * его заказов (ответственный).
 */
import { PageHead } from '@/design-system/components/layout/page-head'
import { QuestionsList } from '@/questions/questions-list'

export function TeamQuestionsPage() {
  return (
    <div>
      <PageHead
        className="mb-4"
        title="Вопросы клиентов"
        subtitle="Вопросы из раздела «Мои вопросы» и из заказов клиентов"
      />
      <QuestionsList side="team" />
    </div>
  )
}
